
export default {
	name: 'Empty',
	props: {
		title: {
			type: String,
			default: ''
		},
		// 空状态图宽度
		width: {
			type: String,
			default: '120px'
		},
		// 空状态图高度
		height: {
			type: String,
			default: '120px'
		},
		// 空状态图距离顶部高度
		top: {
			type: String,
			default: '60px'
		},
		loading: {
			type: Boolean,
			default: false
		},
		description: {
			type: String,
			default: '暂无数据'
		},
		src: {
			type: String,
			default: 'https://oss.pzds.com/img/images/default/default_page.png'
		},
		type: {
			type: String,
			default: ''
		}
	}
}
